module.exports = __webpack_public_path__ + "img/jr-icon-add.247e4e20.png";